import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {trustedHTMLFromString} from "@angular/material/icon/trusted-types";
import {NgbTypeahead} from "@ng-bootstrap/ng-bootstrap";
import {debounceTime, distinctUntilChanged, filter, map, merge, Observable, OperatorFunction, Subject} from "rxjs";
import {AuthorizationService} from "../../services/authorization.service";
import {
  SuperUserMethodsService,
  Venue,
  GameType,
  Date,
  Time,
  TournamentData,
  Category,
} from '../../services/super-user-methods.service';

@Component({
  selector: 'app-private-office',
  templateUrl: './private-office.component.html',
  styleUrls: ['./private-office.component.scss']
})
export class PrivateOfficeComponent implements OnInit {


  public tournamentCreationInitialForm;
  private _tournamentScheduledDate: Date;
  private _tournamentScheduledTime: Time;
  private _tournamentEndAtDate: Date;
  private _tournamentEndAtTime: Time;
  private venuesIdMap: Map<string, number>;
  private gameTypesIdMap: Map<string, number>;
  private tournamentVenuesList: Array<string> = [];
  private gameTypesList: Array<string> = [];
  private _pdfFile: any;
  private _datePickerOpened: boolean = false;
  private createButtonStatesToCSS = {
    active: 'btn btn-log btn-sm',
    disabled: 'blockedCreateButtonStyle',
  };
  private categoriesIdMap: Map<string, number>;
  private categoriesList: Array<string> = [];
  private formatsMap: Map<string, string> = new Map([
    ['Личный', 'personal'],
    ['Командный', 'team']
  ]);

  private _requiredToBeFilledMessage: string = 'Обязательно к заполнению';

  constructor(
    private formBuilder: FormBuilder,
    private authServ: AuthorizationService,
    private suServ: SuperUserMethodsService,
  ) {

    this.tournamentCreationInitialForm = this.formBuilder.group({
      tournamentTitle: ['', [Validators.required]],
      tournamentVenue: ['', [Validators.required]],
      tournamentGameType: ['', [Validators.required]],
      tournamentRegulationsPdf: [''],
      tournamentScheduledDateField: ['', [Validators.required]],
      tournamentScheduledTimeField: ['', [Validators.required]],
      tournamentEndAtDateField: ['', [Validators.required]],
      tournamentEndAtTimeField: ['', [Validators.required]],
      tournamentFormat: ['', [Validators.required]],
      tournamentCategory: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {

    this.suServ.acquireGamesTypes().subscribe((gameTypesList: GameType[]) => {
      this.gameTypesIdMap = this.suServ.transformRawListOfGameTypesToRender(gameTypesList);
      this.setGameTypesList(Array.from(this.gameTypesIdMap.keys()));
    });

    this.suServ.acquireVenues().subscribe((venuesList: Venue[]) => {
      this.venuesIdMap = this.suServ.transformRawListOFVenuesToRender(venuesList);
      this.setTournamentVenuesList(Array.from(this.venuesIdMap.keys()));
    });

    this.suServ.acquireCategories().subscribe((categoriesList: Category[]) => {
      this.categoriesIdMap = this.suServ.transformRawListOfCategoriesToRender(categoriesList);
      this.setCategoriesList(Array.from(this.categoriesIdMap.keys()));
    });

  }


  venueInputFormatter = (value) => value;
  venueResultFormatter = (value) => value;

  @ViewChild('instance', {static: true}) instance: NgbTypeahead;
  subjectsList = [
    {
      focus: new Subject<string>(),
      click: new Subject<string>(),
    },
    {
      focus: new Subject<string>(),
      click: new Subject<string>(),
    },
    {
      focus: new Subject<string>(),
      click: new Subject<string>(),
    },
    {
      focus: new Subject<string>(),
      click: new Subject<string>(),
    },
  ];

  searchTemplate = (listGetter, num) => {
    const template : OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
      const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
      const clicksWithClosedPopup$ = this.subjectsList[num].click.pipe(filter(() => !this.instance.isPopupOpen()));
      const inputFocus$ = this.subjectsList[num].focus;

      return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
        map(term => (term === '' ? listGetter()
            : listGetter().filter(v => v.toLowerCase().startsWith(term.toLowerCase()))
        )))
    }

    return template;
  }

  searchVenue: OperatorFunction<string, readonly string[]> = this.searchTemplate(this.getTournamentVenuesList.bind(this), 0);
  searchGameType: OperatorFunction<string, readonly string[]> = this.searchTemplate(this.getGameTypesList.bind(this), 1);
  searchCategory: OperatorFunction<string, readonly string[]> = this.searchTemplate(this.getCategoriesList.bind(this), 2);
  searchFormat: OperatorFunction<string, readonly string[]> = this.searchTemplate(this.getFormatsList.bind(this), 3);


  createTournament() {
    if (this.allTextFieldsFilled() && this.judgesSelected()) {
      this.suServ.sendTournamentData(this.formTournamentData()).subscribe((response) => {
        // @ts-ignore
        const createdTournamentIdToProceedTo = response?.id;
        window.location.href = `/tournament/${createdTournamentIdToProceedTo}/players`;
      });
    }
  }

  getTournamentVenuesList(): Array<string> {
    return [...this.tournamentVenuesList]
  }

  setTournamentVenuesList(venuesList) {
    this.tournamentVenuesList = [...venuesList];
  }

  getGameTypesList() {
    return [...this.gameTypesList];
  }

  setGameTypesList(gameTypesList) {
    this.gameTypesList = [...gameTypesList];
  }

  getFormatsList() {
    return Array.from(this.formatsMap.keys());
  }

  getCategoriesList() {
    return [...this.categoriesList];
  }

  setCategoriesList(categoriesList) {
    this.categoriesList = [...categoriesList];
  }


  logOutAndRedirect() {
    this.authServ.logOut().subscribe(() => {
      window.location.href = '/';
    });
  }

  set tournamentScheduledDate(value) {
    this._tournamentScheduledDate = value;
  }

  get tournamentScheduledDate() {
    return this._tournamentScheduledDate;
  }

  set tournamentScheduledTime(value) {
    this._tournamentScheduledTime = value;
  }

  get tournamentScheduledTime() {
    return this._tournamentScheduledTime;
  }

  set tournamentEndAtDate(value) {
    this._tournamentEndAtDate = value;
  }

  get tournamentEndAtDate() {
    return this._tournamentEndAtDate;
  }

  set tournamentEndAtTime(value) {
    this._tournamentEndAtTime = value;
  }

  get tournamentEndAtTime() {
    return this._tournamentEndAtTime;
  }

  set pdfFile(value: any) {
    this._pdfFile = value;
  }

  get pdfFile() {
    return this._pdfFile;
  }

  readAndEncodeRegulationsPDF(target) {
    const uploadedFile = target.files[0];
    this.pdfFile = uploadedFile;
    return uploadedFile;
  }


  formFinalData(date_type, time_type): string {
    const [date, time] = [date_type, time_type];

    return `${date.year}-${date.month}-${date.day}T${time.hour}:${time.minute}:00`;
  }

  formTournamentData(): FormData {
    const formData = new FormData();

    formData.append('format', this.formatsMap.get(this.tournamentCreationInitialForm.get('tournamentFormat').value));

    formData.append('category', this.categoriesIdMap.get(this.tournamentCreationInitialForm.get('tournamentCategory').value).toString());

    formData.append('game', this.gameTypesIdMap.get(this.tournamentCreationInitialForm.get('tournamentGameType').value).toString());

    this.suServ.getJudgesIdList().forEach((value) => {
      formData.append('judges', value.toString());
    });

    formData.append('place', this.venuesIdMap.get(this.tournamentCreationInitialForm.get('tournamentVenue').value).toString());

    formData.append('start_at', this.formFinalData(this.tournamentScheduledDate, this.tournamentScheduledTime));

    formData.append('end_at', this.formFinalData(this.tournamentEndAtDate, this.tournamentEndAtTime));

    if(this.pdfFile) {
      formData.append('regulations_file', this.pdfFile);
    }
    formData.append('name', this.tournamentCreationInitialForm.get('tournamentTitle').value);
    return formData;
  }

  get _tournamentTitleField() {
    return this.tournamentCreationInitialForm.get('tournamentTitle');
  }

  get tournamentTitleValue() {
    return this._tournamentTitleField;
  }

  get _tournamentGameTypeField() {
    return this.tournamentCreationInitialForm.get('tournamentGameType');
  }

  get tournamentGameTypeValue() {
    return this._tournamentGameTypeField.value;
  }

  get _tournamentVenueField() {
    return this.tournamentCreationInitialForm.get('tournamentVenue');
  }

  get tournamentVenueValue() {
    return this._tournamentVenueField.value;
  }

  get _tournamentScheduledDateField() {
    return this.tournamentCreationInitialForm.get('tournamentScheduledDateField');
  }

  get _tournamentScheduledTimeField() {
    return this.tournamentCreationInitialForm.get('tournamentScheduledTimeField');
  }

  get _tournamentEndAtDateField() {
    return this.tournamentCreationInitialForm.get('tournamentEndAtDateField');
  }

  get _tournamentEndAtTimeField() {
    return this.tournamentCreationInitialForm.get('tournamentEndAtTimeField');
  }

  get _tournamentFormatField() {
    return this.tournamentCreationInitialForm.get('tournamentFormat');
  }

  get tournamentFormatValue() {
    return this._tournamentFormatField.value;
  }

  get _tournamentCategoryField() {
    return this.tournamentCreationInitialForm.get('tournamentCategory');
  }

  get tournamentCategoryValue() {
    return this._tournamentCategoryField.value;
  }


  allTextFieldsFilled(): boolean {
    return !!(
      this.tournamentTitleValue
      && this.tournamentVenueValue
      && this.tournamentScheduledDate
      && this.tournamentScheduledTime
      && this.tournamentGameTypeValue
      && this.tournamentFormatValue
      && this.tournamentCategoryValue
      && this.judgesSelected()
    );
  }

  judgesSelected(): boolean {
    return !!this.suServ.getJudgesIdList().length;
  }

  get datePickerOpened() {
    return this._datePickerOpened;
  }

  set datePickerOpened(value) {
    this._datePickerOpened = value;
  }

  createButtonStyle() {
    const isActive = this.allTextFieldsFilled() && this.judgesSelected();
    return isActive
      ? this.createButtonStatesToCSS.active
      : this.createButtonStatesToCSS.disabled;
  }

  get expectedToBeFilled(): string {
    return this._requiredToBeFilledMessage;
  }
}

